import axios from '../helpers/axiosHelper'
import { IReduxAction } from '../reducers'
import { CreateDto, FilePartyAction } from '../config/filePartyConfig'

export function addFileParty(fileParty: CreateDto): IReduxAction {
    return {
        type: FilePartyAction.Add,
        payload: axios.post('/file-party', fileParty),
    }
}

export function getPartyChildSuggestions(pivotId: string): IReduxAction {
    return {
        type: FilePartyAction.GetSuggestions,
        payload: axios.get(`/file-party/${pivotId}/suggest`),
    }
}
